import { useState } from "react";
import { Copy, X } from "lucide-react";

interface ShareModalProps {
  isOpen: boolean;
  shareUrl: string;
  onClose: () => void;
}

export function ShareModal({ isOpen, shareUrl, onClose }: ShareModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div
        className="bg-main border border-secondary/50 rounded-lg p-6 max-w-md w-full shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-secondary">Share Recipe</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-secondary/5 rounded transition-colors"
            title="Close"
          >
            <X size={20} className="text-secondary" />
          </button>
        </div>

        <div className="flex gap-3 mb-4">
          <input
            type="text"
            value={shareUrl}
            readOnly
            className="flex-1  px-4 py-2 rounded text-sm text-main/70 bg-primary/50 border border-secondary/20 focus:outline-none"
          />
          <button
            onClick={handleCopy}
            className="btn orange px-4 py-2 rounded font-semibold transition-all duration-150 flex items-center justify-center"
            title={copied ? "Copied!" : "Copy"}
          >
            <Copy size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
